import { FormattedMessage } from 'react-intl'
import { useLocation, useNavigate } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'

export const TableCellPlaceholder = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const onClick = () => {
    navigate({
      to: '/login',
      search: {
        back_url: pathname,
      },
    }).catch(console.error)
  }

  return (
    <Button
      size="small"
      variant="text"
      onClick={onClick}
    >
      <FormattedMessage id="common.controls.loginToView" />
    </Button>
  )
}
